import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { InvoicesPage } from '@/features/billing/invoices-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Factures du locataire (lot L01) : liste, téléchargement, paiement. */
export const Route = createFileRoute('/$tenant/billing/invoices/')({ component: InvoicesRoute });

function InvoicesRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="invoices" crumbs={[{ label: t('nav.items.invoices') }]}>
      <InvoicesPage tenantId={tenant} />
    </ConsoleShell>
  );
}
